import { render, staticRenderFns } from "./RelationTooptip.vue?vue&type=template&id=52dc2b6f&scoped=true"
import script from "./RelationTooptip.vue?vue&type=script&lang=js"
export * from "./RelationTooptip.vue?vue&type=script&lang=js"
import style0 from "./RelationTooptip.vue?vue&type=style&index=0&id=52dc2b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc2b6f",
  null
  
)

export default component.exports